// extracted by mini-css-extract-plugin
export var content = "_4-1";
export var shell = "_4-0";